export default "__VITE_PUBLIC_ASSET__869a0135__"